export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=a8b431e2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/profile/notification/index.vue?vue&type=template&id=a8b431e2&
// module id = 1081
// module chunks = 0